import react, {useContext} from 'react';
import { Box, Grid2 as Grid, Stack, useMediaQuery, useTheme } from '@mui/material';
import { CommitteeInfo, ElectionTimelines, FilerInfo, FinancialSummary, RaceActivitiesChart, ReportLog } from './components';
import { FilersDataContext } from '../../Filers';

const FilerSummary = (): JSX.Element => {
    const theme = useTheme();
    const filerDataContext = useContext(FilersDataContext);
    const currentFilerPayload = filerDataContext.currentFilerPayload;

    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });

    return (
        <Grid container spacing={4} marginTop={2}>
            {
                !currentFilerPayload?.filer.isCandidateOnly &&
                <CommitteeInfo></CommitteeInfo>
            }
            {
                currentFilerPayload?.filer.isCandidate?
                <FilerInfo></FilerInfo>
                :
                isMd && <Grid size={{ xs: 12, md: 5.5 }}></Grid>
            }
            {
                currentFilerPayload?.filer.isCandidateOnly && isMd &&
                <Grid size={5.5}></Grid>
            }
            {
                currentFilerPayload?.filer.isActive && !currentFilerPayload?.filer.accountType.isBank &&
                <>
                {
                    !currentFilerPayload?.filer.accountType.isIePac &&
                    <FinancialSummary></FinancialSummary>
                }
                 <ReportLog></ReportLog>
                </>
            }
            {
                currentFilerPayload?.filer.isCandidate && currentFilerPayload?.filer.tags && currentFilerPayload?.filer.tags.length>0 &&
                <>
                    <ElectionTimelines></ElectionTimelines>
                    <RaceActivitiesChart></RaceActivitiesChart>
                </>
            }
        </Grid>
    );
  };

  export default FilerSummary;